import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixCalendarScheduletimeframesV3ScheduleTimeFramesServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/schedule-timeframes-3',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/calendar/v3/schedules/timeframe',
        destPath: '/v3/schedules/timeframe',
      },
    ],
    _: [
      {
        srcPath: '/_api/calendar/v3/schedules/timeframe',
        destPath: '/v3/schedules/timeframe',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/calendar/v3/schedules/timeframe',
        destPath: '/v3/schedules/timeframe',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/calendar/v3/schedules/timeframe',
        destPath: '/v3/schedules/timeframe',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_calendar_schedule-time-frames';

/** Retrieves a schedule time frame by schedule ID. */
export function getScheduleTimeFrame(
  payload: object
): RequestOptionsFactory<any> {
  function __getScheduleTimeFrame({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.calendar.v3.schedule_time_frame',
      method: 'GET' as any,
      methodFqn:
        'wix.calendar.scheduletimeframes.v3.ScheduleTimeFramesService.GetScheduleTimeFrame',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixCalendarScheduletimeframesV3ScheduleTimeFramesServiceUrl({
        protoPath: '/v3/schedules/timeframe/{id}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'scheduleTimeFrame.firstEventStartDate.utcDate' },
              { path: 'scheduleTimeFrame.lastEventEndDate.utcDate' },
              { path: 'scheduleTimeFrame.adjustedFirstEventStartDate.utcDate' },
              { path: 'scheduleTimeFrame.adjustedLastEventEndDate.utcDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getScheduleTimeFrame;
}

/**
 * Retrieves a list of schedule time frames by schedule IDs.
 *
 *
 * Sorted by schedule ID in ascending order.
 */
export function listScheduleTimeFrames(
  payload: object
): RequestOptionsFactory<any> {
  function __listScheduleTimeFrames({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.calendar.v3.schedule_time_frame',
      method: 'GET' as any,
      methodFqn:
        'wix.calendar.scheduletimeframes.v3.ScheduleTimeFramesService.ListScheduleTimeFrames',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixCalendarScheduletimeframesV3ScheduleTimeFramesServiceUrl({
        protoPath: '/v3/schedules/timeframe',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'scheduleTimeFrames.firstEventStartDate.utcDate' },
              { path: 'scheduleTimeFrames.lastEventEndDate.utcDate' },
              {
                path: 'scheduleTimeFrames.adjustedFirstEventStartDate.utcDate',
              },
              { path: 'scheduleTimeFrames.adjustedLastEventEndDate.utcDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listScheduleTimeFrames;
}
